// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-logo-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.upload-logo-modal-content {
  background: #ffffff;
  border-radius: 1rem;
  width: 75vw;
  max-width: 75vw;
  height: 75vh;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 20px 48px -8px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.upload-logo-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.75rem 1.25rem;
  border-bottom: 1px solid #f3f4f6;
}

.upload-logo-modal-header h2 {
  margin: 0;
  color: #374151;
  font-size: 1.55rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.upload-logo-modal-close {
  background: none;
  border: none;
  font-size: 2.4rem;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: color 0.15s;
  flex-shrink: 0;
}

.upload-logo-modal-close:hover {
  color: #374151;
}

.upload-logo-form {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

/* Dropzone */
.upload-logo-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2.25rem 1.5rem;
  border: 2px dashed #e5e7eb;
  border-radius: 0.875rem;
  background: #f9fafb;
  text-align: center;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    transform 0.15s ease;
  cursor: default;
  flex: 1 1;
}

.upload-logo-dropzone--over {
  border-color: #f97316;
  background: #fff7ed;
  transform: scale(1.01);
}

.upload-logo-dropzone--selected {
  border-color: #16a34a;
  background: #f0fdf4;
}

.upload-logo-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f97316;
  margin-bottom: 0.5rem;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.upload-logo-icon svg {
  width: 28px;
  height: 28px;
}

.upload-logo-label {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: -0.01em;
}

.upload-logo-sublabel {
  margin: 0.1rem 0;
  font-size: 1.1rem;
  color: #9ca3af;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.upload-logo-hint {
  margin: 0.25rem 0 0;
  font-size: 1.1rem;
  color: #9ca3af;
}

/* Prévisualisation */
.upload-logo-preview {
  width: 120px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;
  border: 1px solid #e5e7eb;
}

.upload-logo-preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.upload-logo-filename {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #15803d;
  word-break: break-all;
  max-width: 90%;
}

.upload-logo-size {
  margin: 0;
  font-size: 1.2rem;
  color: #9ca3af;
}

.upload-logo-change {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #9ca3af;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  margin-top: 0.25rem;
  font-family: inherit;
  transition: color 0.15s;
}

.upload-logo-change:hover {
  color: #374151;
}

/* Error */
.upload-logo-error {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  color: #b91c1c;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 0.625rem;
  padding: 0.875rem 1rem;
}

/* Actions */
.upload-logo-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/UploadLogoModal/UploadLogoModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;;wCAEsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB;;;wBAGsB;EACtB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".upload-logo-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.upload-logo-modal-content {\n  background: #ffffff;\n  border-radius: 1rem;\n  width: 75vw;\n  max-width: 75vw;\n  height: 75vh;\n  max-height: 75vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 20px 48px -8px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.upload-logo-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.75rem 1.25rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.upload-logo-modal-header h2 {\n  margin: 0;\n  color: #374151;\n  font-size: 1.55rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.upload-logo-modal-close {\n  background: none;\n  border: none;\n  font-size: 2.4rem;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  transition: color 0.15s;\n  flex-shrink: 0;\n}\n\n.upload-logo-modal-close:hover {\n  color: #374151;\n}\n\n.upload-logo-form {\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Dropzone */\n.upload-logo-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 2.25rem 1.5rem;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.875rem;\n  background: #f9fafb;\n  text-align: center;\n  transition:\n    border-color 0.2s ease,\n    background 0.2s ease,\n    transform 0.15s ease;\n  cursor: default;\n  flex: 1;\n}\n\n.upload-logo-dropzone--over {\n  border-color: #f97316;\n  background: #fff7ed;\n  transform: scale(1.01);\n}\n\n.upload-logo-dropzone--selected {\n  border-color: #16a34a;\n  background: #f0fdf4;\n}\n\n.upload-logo-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f97316;\n  margin-bottom: 0.5rem;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.upload-logo-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.upload-logo-label {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #1f2937;\n  letter-spacing: -0.01em;\n}\n\n.upload-logo-sublabel {\n  margin: 0.1rem 0;\n  font-size: 1.1rem;\n  color: #9ca3af;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.upload-logo-hint {\n  margin: 0.25rem 0 0;\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n\n/* Prévisualisation */\n.upload-logo-preview {\n  width: 120px;\n  height: 80px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.25rem;\n  border: 1px solid #e5e7eb;\n}\n\n.upload-logo-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.upload-logo-filename {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #15803d;\n  word-break: break-all;\n  max-width: 90%;\n}\n\n.upload-logo-size {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #9ca3af;\n}\n\n.upload-logo-change {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: #9ca3af;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  margin-top: 0.25rem;\n  font-family: inherit;\n  transition: color 0.15s;\n}\n\n.upload-logo-change:hover {\n  color: #374151;\n}\n\n/* Error */\n.upload-logo-error {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 1.3rem;\n  color: #b91c1c;\n  background: #fff1f2;\n  border: 1px solid #fecdd3;\n  border-radius: 0.625rem;\n  padding: 0.875rem 1rem;\n}\n\n/* Actions */\n.upload-logo-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding-top: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
